export { default } from './platform-sidebar';
